import React from 'react'
import ContentLoader from 'react-content-loader'

const HeadBodyGrid = ({ ...rest }) => (
  <ContentLoader 
    height="350px" 
    width="100%" {...rest}    
    backgroundColor="#cccccc"
    foregroundColor="#232323"
  >
    <rect x="0" y="21" rx="4" ry="4" width="100%" height="11%" />
    <rect x="0" y="80" rx="2" ry="2" width="100%" height="70%" />
  </ContentLoader>
)

export default HeadBodyGrid;

//viewBox="0 0 265 230"